(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-cards"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hdt-variant-card-sync')) {
    class HdtVariantCardSync extends HTMLElement {
      connectedCallback() {
        customElements.whenDefined('hdt-variant-picker').then(() => {
          requestAnimationFrame(() => this.waitForPicker());
        });
      }

      disconnectedCallback() {
        if (this.pickerObserver) this.pickerObserver.disconnect();
      }

      waitForPicker() {
        const picker = this.closest('hdt-variant-picker');
        if (!picker) return;

        if (!picker.classList.contains('loading')) {
          this.syncInitialSelection();
          return;
        }

        this.pickerObserver = new MutationObserver(() => {
          if (picker.classList.contains('loading')) return;

          this.pickerObserver.disconnect();
          this.syncInitialSelection();
        });

        this.pickerObserver.observe(picker, {
          attributes: true,
          attributeFilter: ['class'],
        });
      }

      syncInitialSelection() {
        const input = this.querySelector('input[is-value]:checked');
        const picker = this.closest('hdt-variant-picker');

        if (!input || !picker) return;
        if (this.dataset.initialSelectionSynced === 'true') return;

        this.dataset.initialSelectionSynced = 'true';
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    customElements.define('hdt-variant-card-sync', HdtVariantCardSync);
  }
  } catch(e) { console.error(e); }
})();

})();
